import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCheckEmpty = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M10 16.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13m0 1.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
      clipRule="evenodd"
    />
    <path d="M8.8 11.17 7.366 9.734a.8.8 0 0 0-1.132 1.131l2 2a.8.8 0 0 0 1.132 0l4-4a.8.8 0 0 0-1.132-1.132z" />
  </svg>
);
export default SvgCheckEmpty;
